import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=1c6779d6&scoped=true&"
import script from "./DisclaimerModal.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6779d6",
  null
  
)

export default component.exports